<template>
    <section id="accordion" role="tablist">
        <div class="panel pb-1" v-for="category in categories" :key="category.id">
            <div class="panel-header" role="tab" :id="'heading_c'+category.id">
                <h4 class="panel-title">
                    <a data-toggle="collapse" :href="'#collapse_c'+category.id" role="button" aria-expanded="false" aria-controls="collapseOne" data-parent="#accordion">
                        <div class="row">
                            <div class="col-12 col-sm-9">
                                <span class="numbered">{{category.name}}</span>
                            </div>
                            <div class="d-none d-sm-block col-3 text-align--right">
                                <span class="text-muted pr-1"></span>
                            </div>
                        </div>
                    </a>
                </h4>
            </div>
            <div :id="'collapse_c'+category.id" class="panel-collapse collapse" role="tabpanel" :aria-labelledby="'heading_c'+category.id">
                <div class="panel-body py-1 px-1 py-md-2 px-md-3">
                    <div v-for="element in elements[category.id]" :key="element.id">
                        <div class="row mt-1">
                            <div class="col-12 col-sm-9">{{element.name}} <i v-if="fields(element).info !== null" v-b-tooltip.hover :title="fields(element).info" class="fa fa-info-circle ml-1 text-red"></i></div>
                            <div class="d-none d-sm-block col-3 text-align--right pr-1 text-muted"></div>
                        </div>
                        <div v-if="fields(element).type === 'ElementItemSelect'">
                            <fieldset class="form-group">
                                <v-select v-model="selected['category_'+category.id+'-select_'+element.id]" :options="choises(element).choises" label="content"></v-select>
                            </fieldset>
                            <div v-for="(c, index) in choises(element).choises" :key="'textfields_'+index" class="row" v-if="c.textfields.length > 0" v-show="isEquivalent(c, selected['category_'+category.id+'-select_'+element.id])">
                                <div v-for="(textfield, tidx) in c.textfields" :key="tidx" class="col-xs-12 col-sm textfield pb-1" :data-show="selected['category_'+category.id+'-select_'+element.id]">
                                    <input type="text" v-model="selected['textfield_'+element.id+'_'+tidx]" :placeholder="textfield.placeholder" class="form-control">
                                </div>
                            </div>
                        </div>
                        <div v-if="fields(element).type === 'ElementItemRadio'">
                            <div v-for="(choise, idx) in choises(element).choises" :key="'choises_'+idx" class="d-inline">
                                <input class="form-check-input" type="radio" v-model="selected['category_'+category.id+'-radio_'+element.id]" :name="'radio_'+element.id" :value="choise.id" :id="choise.id">
                                <label class="form-check-inline mr-1" :for="choise.id">{{choise.content}}</label>
                            </div>
                            <div v-for="(c, index) in choises(element).choises" :key="'textfields_'+index" class="row" v-if="c.textfields.length > 0" v-show="c.id === selected['category_'+category.id+'-radio_'+element.id]">
                                <div v-for="(textfield, tidx) in c.textfields" :key="tidx" class="col-xs-12 col-sm textfield pb-1">
                                    <input type="text" v-model="selected['textfield_'+element.id+'_'+tidx]" :placeholder="textfield.placeholder" class="form-control">
                                </div>
                            </div>
                        </div>
                        <div v-else-if="fields(element).type === 'ElementItemCheckbox'">
                            <div v-for="(choise, idx) in choises(element).choises" :key="idx" class="d-inline">
                                <input class="form-check-input"  :id="choise.id" v-model="selected['category_'+category.id+'-checkbox_' + element.id][choise.id]" value="true" :name="'checkbox_'+element.id" type="checkbox">
                                <label class="form-check-inline" :for="choise.id">{{choise.content}}</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {};
  },
  computed: {
    categories() {
      return this.data.categories;
    },
    elements() {
      return this.data.elements;
    },
    selected: {
      get() {
        return this.$store.state.form.form.choises;
      },
      set(val) {
        window.console.log(val);
      }
    }
  },
  watch: {
    selected: {
      handler(val) {
        this.$store.commit("updateChoises", val);
      },
      deep: true
    }
  },
  methods: {
    /**
     * Return element fields
     */
    fields(element) {
      let data = JSON.parse(element.data);
      return data;
    },

    /**
     * Return element choises
     */
    choises(element) {
      let data = JSON.parse(element.data);
      return data.choises;
    },
    isEquivalent(a, b) {
      // Create arrays of property names
      if (a === Object(a)) {
        // var aProps = Object.getOwnPropertyNames(a);
      } else {
        return false;
      }
      if (b === Object(b)) {
        // var bProps = Object.getOwnPropertyNames(b);
      } else {
        return false;
      }

      if (a.id === b.id) {
        return true;
      }
      return false;
    }
  }
};
</script>

<style lang="scss">
.textfield {
  min-width: 33%;
}
</style>
